import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import GameModesSection from '../components/sections/GameModesSection';
import LeaderboardsSection from '../components/sections/LeaderboardsSection';
import HowToPlaySection from '../components/sections/HowToPlaySection';
import DownloadCTASection from '../components/sections/DownloadCTASection';

const Home: React.FC = () => {
  return (
    <>
      <HeroSection />
      <GameModesSection />
      <LeaderboardsSection />
      <HowToPlaySection />
      <DownloadCTASection />
    </>
  );
};

export default Home;
